module.exports = __webpack_public_path__ + "img/house-day.f6c9e17a.svg";